import {InjectionToken} from "@angular/core";

/**
 * @type {InjectionToken} Angular DI provider token for formatter service implementations.
 */
export const FormatterServiceToken: InjectionToken<FormatterService> = new InjectionToken<FormatterService>("core.formatterservice");

/**
 * The formatter service contains all general formatter utilities that we will use in our application. They are used to
 * convert certain data formats to more human friendly string presentation forms.
 *
 * The methods in this interface were defined that they can work well together with the ECMAScript Internationalization
 * API (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl), so we can easily use
 * Intl implementations in our service implementations.
 */
export interface FormatterService {

    formatCardNumber(aCardNumber: string): string;

    formatPhoneNumber(aPhoneNumber: string): string;

    formatDate(aDate: Date, pattern?: string): string;

    formatDateTime(aDate: Date, pattern?: string): string;
}
